import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { callable } from 'src/app/components/callable';

@Injectable({
  providedIn: 'root'
})
export class FamerServiceService {

  path = environment.apiUrl2;

  constructor(private http: HttpClient) { }

  GetAgriStatusProvinceYearOne(datayear: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriStatusProvinceYearOne';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriMemberYearDataSum(datayear: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriMemberYearDataSum';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriCommitteeYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/AgriCommittee/GetAgriCommitteeYear';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriStatusSumYearAll(): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriStatusSumYearAll';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriAssetUseItemYear(PurchaseYear: string): Observable<any> { //404
    let URL = this.path + 'api/Asset/GetAgriAssetUseItemYear';
    URL = callable.setPathParam(URL);
    let body = {
      PurchaseYear: PurchaseYear
    }

    return this.http.post(URL, body);
  }

  GetAgriAgeYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriAgeYear';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriRegisterQiutYears(): Observable<any> {
    let URL = this.path + 'api/StandardData/GetAgriRegisterQiutYears';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriEndmonthYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriEndmonthYear';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriList(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriList';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }

    return this.http.post(URL, body);
  }

  GetAgriStandardYear(): Observable<any> {
    let URL = this.path + 'api/StandardData/GetAgriStandardYear';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriCommitteeProvinceYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/AgriCommittee/GetAgriCommitteeProvinceYear';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetDistinctAgriCommitteeYear(): Observable<any> {
    let URL = this.path + 'api/AgriCommittee/GetDistinctAgriCommitteeYear';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriOfficerYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriOfficerYear';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriMemberProvinceYears(datayear: string): Observable<any> {
    let URL = this.path + 'api/Member/GetAgriMemberProvinceYears';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriMemberYearData(datayear: string): Observable<any> {
    let URL = this.path + 'api/Member/GetAgriMemberYearData';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetAgriDistinctMemberYearData(): Observable<any> {
    let URL = this.path + 'api/Member/GetAgriDistinctMemberYearData';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetDistinctAgriAssetYear(): Observable<any> {
    let URL = this.path + 'api/Asset/GetDistinctAgriAssetYear';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriAssetUseYear(PurchaseYear: string): Observable<any> {
    let URL = this.path + 'api/Asset/GetAgriAssetUseYear';
    URL = callable.setPathParam(URL);
    let body = {
      PurchaseYear: PurchaseYear
    }

    return this.http.post(URL, body);
  }

  GetAgriDistinctAgeYear(): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriDistinctAgeYear';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriEndmonthYearDistinct(): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriEndmonthYearDistinct';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriBusinessEachProvince(DataYear: string, OrgOrgId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBusinessEachProvince';
    URL = callable.setPathParam(URL);
    let body = {
      DataYear: DataYear,
      OrgOrgId: OrgOrgId
    }

    return this.http.post(URL, body);
  }

  GetAgriBusinessYear(datayear: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBusinessYear';
    URL = callable.setPathParam(URL);
    let body = {
      datayear: datayear
    }

    return this.http.post(URL, body);
  }

  GetDistinctAgriBusinessProvinceYear(): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetDistinctAgriBusinessProvinceYear';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetLastestProfile(AgriId: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetLastestProfile';
    URL = callable.setPathParam(URL);
    let body = {
      AgriId: AgriId
    }

    return this.http.post(URL, body);
  }

  GetAgriMemberItemYearByAgriId(AgriId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetAgriMemberItemYearByAgriId';
    URL = callable.setPathParam(URL);
    let body = {
      AgriId: AgriId
    }

    return this.http.post(URL, body);
  }

  GetAgriAssetYear(AgriId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriAssetYear/' + AgriId;
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriMachinesByRegister(AgriId: string): Observable<any> {
    let URL = this.path + 'api/Machine/GetAgriMachinesByRegister/' + AgriId;
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriCollectYear(AgriId: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriCollectYear/' + AgriId;
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriBusinessLastest(AgriId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBusinessLastest';
    URL = callable.setPathParam(URL);
    let body = {
      AgriId: AgriId
    }

    return this.http.post(URL, body);
  }

  GetCommitteeItemYearByAgriId(AgriId: string): Observable<any> {
    let URL = this.path + 'api/AgriCommittee/GetCommitteeItemYearByAgriId';
    URL = callable.setPathParam(URL);
    let body = {
      AgriId: AgriId
    }

    return this.http.post(URL, body);
  }

  GetAgriStandardYearAll(): Observable<any> {
    let URL = this.path + 'api/StandardData/GetAgriStandardYearAll';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriStatusProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriStatusProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriMemberEachProvinceLastestYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetAgriMemberEachProvinceLastestYear';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriCommiteeProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/AgriCommittee/GetAgriCommiteeProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriStandardProvinceYearBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/StandardData/GetAgriStandardProvinceYearBySearch';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }


  GetAgriBusinessMap(DataYear: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBusinessMap';
    URL = callable.setPathParam(URL);
    let body = {
      DataYear: DataYear
    }

    return this.http.post(URL, body);
  }

  GetAgriEndmonthProvinceYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriEndmonthProvinceYear';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriBusinessMapBySearch(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBusinessMapBySearch';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriMachineYear(AgriPurchaseYear: string): Observable<any> {
    let URL = this.path + 'api/Machine/GetAgriMachineYear';
    URL = callable.setPathParam(URL);
    let body = {
      AgriPurchaseYear: AgriPurchaseYear
    }
    return this.http.post(URL, body);

  }

  GetAgriBussinessTypeProvinceYear(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBussinessTypeProvinceYear';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }


  GetAgriStatusTypeProvinceYearLastest(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriStatusTypeProvinceYearLastest';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriStatusSumYearCategorieAll
    (): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriStatusSumYearCategorieAll';
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }

  GetAgriOracleCountNEW(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/AgriProfile/GetAgriOracleCountNEW';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetAgriSumMemberNew(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetAgriSumMemberNew';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetOracleSumProvinceYearSearchAgri(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetOracleSumProvinceYearSearchAgri';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetCoopMemberProvinceYearSearchAgri(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Member/GetCoopMemberProvinceYearSearchAgri';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetBussinessProvinceYearSumAgri(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetBussinessProvinceYearSumAgri';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetAgriSumCommitteeNew(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopCommittee/GetAgriSumCommitteeNew';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetAgriSumOfficer(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriSumOfficer';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetAgriStandardTypeSum(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/StandardData/GetAgriStandardTypeSum';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetAgriOracleTypesNew(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriOracleTypesNew';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);
  }

  GetAgriFinanceNew(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriFinanceNew';
    URL = callable.setPathParam(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriFinanceType(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriFinanceTypeNew';
    URL = callable.setPathParam(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriBussiness(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriBussinessNew';
    URL = callable.setPathParam(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriBussinessType(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriBussinessTypeNew';
    URL = callable.setPathParam(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriProfileBussiness(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriProfileBussinessNew';
    URL = callable.setPathParam(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriProfileBussinessType(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriProfileBussinessTypeNew';
    URL = callable.setPathParam(URL, true);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriProfilesAll(CoopNameTh: string): Observable<any> {
    let URL = this.path + 'api/CoopProfile/GetAgriProfilesAll';
    URL = callable.setPathParam(URL);
    let body = {
      CoopNameTh: CoopNameTh
    }
    return this.http.post(URL, body);

  }

  GetAgriAssetDesc(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Asset/GetAgriAssetDesc';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriMachineSumDesc(OrgOrgId: string, PhakId: string, KhetId: string): Observable<any> {
    let URL = this.path + 'api/Machine/GetAgriMachineSumDesc';
    URL = callable.setPathParam(URL);
    let body = {
      OrgOrgId: OrgOrgId,
      PhakId: PhakId,
      KhetId: KhetId
    }
    return this.http.post(URL, body);

  }

  GetAgriMachineByCoopId(CoopInfoCoopId: any): Observable<any> {
    let URL = this.path + 'api/Machine/GetAgriMachineByCoopId';
    URL = callable.setPathParam(URL);
    let body = {
      CoopInfoCoopId: CoopInfoCoopId
    }
    return this.http.post(URL, body);

  }

  GetAgriAssetByCoopId(CoopInfoCoopId: any): Observable<any> {
    let URL = this.path + 'api/Asset/GetAgriAssetByCoopId';
    URL = callable.setPathParam(URL);
    let body = {
      CoopInfoCoopId: CoopInfoCoopId
    }
    return this.http.post(URL, body);

  }

  GetAgriFinanceFiveYears(CoopId: string): Observable<any> {
    let URL = this.path + 'api/Finance/GetAgriFinanceFiveYears';
    URL = callable.setPathParam(URL);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }


  GetAgriBusinessFiveYears(CoopId: string): Observable<any> {
    let URL = this.path + 'api/BusinessData/GetAgriBusinessFiveYears';
    URL = callable.setPathParam(URL);
    let body = {
      CoopId: CoopId
    }
    return this.http.post(URL, body);

  }

  GetAgriProfileBussinessFiveYears(CoopId: string): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetAgriProfileBussinessFiveYears';
    URL = callable.setPathParam(URL);
    let body = {
      agriId: CoopId
    }
    return this.http.post(URL, body);

  }

  GetLastestProfileAGRI(agriId): Observable<any> {
    let URL = this.path + 'api/ProfileData/GetLastestProfileAGRI/' + agriId;
    URL = callable.setPathParam(URL);
    return this.http.get(URL);
  }


}
